<template>
    <footer class="footer py-40 py-md-52">
        <v-container>
            <v-row justify-lg="space-between" align-lg="center" class="flex-column-reverse flex-lg-row">
                <v-col cols="12" lg="10">
                    <p class="font-weight-bold font-size-14 font-size-lg-16 mb-10 mb-lg-0">
                        Meitextile co., ltd.
                    </p>
                    <div class="d-md-flex mb-6 mb-lg-8 flex-wrap">
                        <p class="mb-2 mb-0 mr-md-8 mr-lg-18">
                            ADDRESS. <span>[04927] 344, Neungdong-ro, Gwangjin-gu, Seoul, Republic of Korea</span>
                        </p>
                        <p class="mb-2 mb-0 mr-md-8 mr-lg-18">
                            TEL. <span>+82 02 752 9510</span>
                        </p>
                        <p class="mb-2 mb-0 mr-md-8 mr-lg-18">
                            FAX. <span>02 706 1649</span>
                        </p>
                        <p>
                            EMAIL. <span>Meitex@meitex.co.kr</span>
                        </p>
                    </div>
                    <p>
                        <span>© 2022. Meitextile co., ltd. All rights reserved</span>
                    </p>
                </v-col>
                <v-col cols="8" sm="5" lg="2" class="d-flex justify-lg-end mb-24 mb-lg-0">
                    <v-img src="/images/ci-dark.svg" contain max-width="220"></v-img>
                </v-col>
            </v-row>
        </v-container>
        <u-scroll-top></u-scroll-top>
    </footer>
</template>

<script>
import UScrollTop from "@/components/dumb/u-scroll-top.vue";
// import api from "@/api";

export default {
    components: {
        UScrollTop,
    },
    // data() {
    //     return {
    //         setting: null,
    //     };
    // },
    // computed: {
    //     info() {
    //         return this.setting?.footer?.info || [];
    //     },
    //     sns() {
    //         return (this.setting?.footer?.sns || []).filter(({ shows }) => shows);
    //     },
    // },
    // mounted() {
    //     this.init();
    // },
    // methods: {
    //     async init() {
    //         const { setting } = await api.v1.setting.get();
    //         this.setting = setting;
    //     },
    // },
};
</script>

<style scoped>
.footer {
    font-size: 1.2rem;
    line-height: 20px;
    color: var(--on-primary_dark1);
    background-color: #14191c;
}
.footer span{
    color: var(--on-primary_dark2);
}
.footer .container{
    max-width: calc(var(--container-lg) + 12px*2);
}
@media (min-width: 576px) {
}
@media (min-width: 768px) {
}
@media (min-width: 1024px) {
    .footer {
        font-size: 1.4rem;
        line-height: 30px;
    }
}
@media (min-width: 1200px) {
}
</style>
